module.exports = __webpack_public_path__ + "static/media/thumbs_dsc_4582.5d790325.jpg";